import apiClient from './client';

export type IntegrationType = 'JIRA' | 'JELLYFISH' | 'BONUSLY';

export interface IntegrationConfigListItem {
  id: string;
  type: IntegrationType;
  status: string;
  name: string;
  baseUrl?: string | null;
  email?: string | null;
  workspaceId?: string | null;
  spaceKey?: string | null;
  hasApiToken: boolean;
  hasApiKey: boolean;
  apiTokenMasked?: string | null;
  apiKeyMasked?: string | null;
  updatedAt: string;
}

export const integrationsConfigApi = {
  list: () => apiClient.get<IntegrationConfigListItem[]>('/integrations-config'),
  getOne: (type: IntegrationType) => apiClient.get(`/integrations-config/${type}`),
  upsert: (type: IntegrationType, payload: any) => apiClient.put(`/integrations-config/${type}`, payload),
  reveal: (type: IntegrationType) => apiClient.post(`/integrations-config/${type}/reveal`),
  importEnv: () => apiClient.post<IntegrationConfigListItem[]>('/integrations-config/import-env'),
};


